import { lazy } from "react";

// project import
import Loadable from "components/Loadable";
import DashboardLayout from "layout/Dashboard";
import PagesLayout from "layout/Pages";
import SimpleLayout from "layout/Simple";
// types
import { SimpleLayoutType } from "types/config";
import DashboardDefault from "../pages/extra-pages/pages/dashboard";
import Users from "../pages/extra-pages/pages/roles-managment/users/user";
import Countries from "../pages/extra-pages/pages/site-params/countries/countries";
import Roles from "../pages/extra-pages/pages/roles-managment/roles/roles";
import VacanciesSub from "../pages/extra-pages/pages/orders-managment/subscriptions/vacancySubscription/VacanciesSubscription";
import ResumeSub from "../pages/extra-pages/pages/orders-managment/subscriptions/resumesSubscription/ResumeSubscription";
import Banners from "../pages/extra-pages/pages/ads-managment/ads/banners/banners";
import BestPlace from "../pages/extra-pages/pages/ads-managment/ads/bestPlace/Bestplace";
import TopCompany from "../pages/extra-pages/pages/ads-managment/ads/topCompany/TopCompany";
import JobTypes from "../pages/extra-pages/pages/site-params/jobTypes/jobTypes";
import JobAva from "../pages/extra-pages/pages/site-params/jobAva/jobAva";
import Degree from "../pages/extra-pages/pages/site-params/degree/degree";
import Educational from "../pages/extra-pages/pages/site-params/educational/Educational";
import Language from "../pages/extra-pages/pages/site-params/languages/Language";
import Skills from "../pages/extra-pages/pages/site-params/skills/Skills";
import Payment from "../pages/extra-pages/pages/payment-management/payment/Payment";
import Question from "../pages/extra-pages/pages/site-params/Question/question";
// import ActiveResume from "../pages/extra-pages/resumes/active&inactive/active";
// import InactiveResume from "../pages/extra-pages/resumes/active&inactive/inactive";
import BannerPlace from "../pages/extra-pages/pages/site-params/bannerPlace/bannerPlace";
import CompanyProfileList from "../pages/extra-pages/pages/companies-managment/company/companyTable/CompanyProfile";

import VacanciesJobs from "../pages/extra-pages/pages/vacancies-management/vacancies/Vacancies";
import CommentActionsList from "../pages/extra-pages/pages/site-params/commentAction/commentActions";
import ReportList from "../pages/extra-pages/pages/site-params/report/Report";
import TitleList from "../pages/extra-pages/pages/site-params/title/Title";
import CurrencyList from "../pages/extra-pages/pages/site-params/currency/Currency";
import BankList from "../pages/extra-pages/pages/site-params/bank/Bank";
import VacanciesList from "../pages/extra-pages/pages/vacancies-management/vacancy/Vacancies";
import MailListPage from "../pages/extra-pages/pages/site-params/mail-templates/mails";
import AdminResumeNoteType from "../pages/extra-pages/pages/admin-resume-note-type/adminResumeNoteType";
import FormVacancyManagmentEdit from "../pages/extra-pages/pages/vacancies-management/vacancy/EditVacancy";
import StaticPages from "../pages/extra-pages/pages/static-pages/index";
import FormRolesManagmentEdit from "../pages/extra-pages/pages/roles-managment/roles/rolesEdit";
import FormCustomerAdd from "../pages/extra-pages/pages/site-params/mail-templates/FormCustomerAdd";
import Translations from "../pages/extra-pages/pages/site-params/translations/translations";
import CompanyActivities from "../pages/extra-pages/pages/companies-managment/company-activities/activities";
import JobActivities from "../pages/extra-pages/pages/site-params/jopActivities/activities";
import CourseCategories from "../pages/extra-pages/pages/course-managment/course-categories/categories";
import AddEditPage from "../pages/extra-pages/pages/static-pages/AddEditPage";
import Articles from "../pages/extra-pages/pages/knowledge-center/articles-list";
import AddEditArticle from "../pages/extra-pages/pages/knowledge-center/articles-list/AddEditArticle";
import Comments from "../pages/extra-pages/pages/knowledge-center/comments-list";
import AddEditComment from "../pages/extra-pages/pages/knowledge-center/comments-list/AddEditComment";
import ArticlesCategories from "../pages/extra-pages/pages/knowledge-center/articles-categories/index";
import ApplicationsList from "../pages/extra-pages/pages/vacancies-management/applications/applications";
import AddEditCourse from "../pages/extra-pages/pages/course-managment/training-courses/AddEditCourse";
import TrainingCourses from "../pages/extra-pages/pages/course-managment/training-courses";
import TrainingCenters from "../pages/extra-pages/pages/course-managment/training-centers";
import AddEditCompanyProfile from "../pages/extra-pages/pages/companies-managment/company/AddEditCompanyProfile";
import SearchCompanies from "../pages/extra-pages/pages/companies-managment/company/SearchCompanies";

import ViewCompanyDetails from "../pages/extra-pages/pages/companies-managment/company/companyDetails/ViewCompanyDetails";
import CommentActions from "../pages/extra-pages/pages/site-params/commentAction/commentActions";
import Categories from "../pages/extra-pages/pages/site-params/categories/categories";
import CompanyReplies from "../pages/extra-pages/pages/companies-managment/companies-replies/CompanyReplies";
import CompanyReports from "../pages/extra-pages/pages/companies-managment/company-reports/CompanyReports";
import CompanyComments from "../pages/extra-pages/pages/companies-managment/company-comments/companyComments";
import CompaniesAccounts from "../pages/extra-pages/pages/roles-managment/companies-accounts/CompaniesAccounts";
import JobSeekers from "../pages/extra-pages/pages/resumes-managment/job-seekers/JobSeekers";
import AddEditJobSeeker from "../pages/extra-pages/pages/resumes-managment/job-seekers/AddEditJobSeeker";
import ResumeForm from "../pages/extra-pages/pages/resumes-managment/ResumeForm";
import Resumes from "../pages/extra-pages/pages/resumes-managment/Resumes";
import SearchResumes from "../pages/extra-pages/pages/resumes-managment/SearchResumes";
import AddEditVacancy from "../pages/extra-pages/pages/vacancies-management/vacancies/AddEditVacancy";
import VacanciesPackages from "../pages/extra-pages/pages/orders-managment/packages/vacaciensPackages/VacanciesPackages";
import ResumePackages from "../pages/extra-pages/pages/orders-managment/packages/resumesPackages/ResumePackages";
import Orders from "../pages/extra-pages/pages/orders-managment/order/orders/Orders";
import AddEditOrder from "../pages/extra-pages/pages/orders-managment/order/orders/AddEditOrder";
import PurchasedResumes from "../pages/extra-pages/pages/orders-managment/purchased-resumes/PurchasedResumes";

const MaintenanceError = Loadable(
  lazy(() => import("../pages/maintenance/404"))
);
const MaintenanceError500 = Loadable(
  lazy(() => import("../pages/maintenance/500"))
);
const MaintenanceUnderConstruction = Loadable(
  lazy(() => import("../pages/maintenance/under-construction"))
);
const MaintenanceComingSoon = Loadable(
  lazy(() => import("../pages/maintenance/coming-soon"))
);

const AppContactUS = Loadable(lazy(() => import("../pages/contact-us")));
// render - sample page
//const SamplePage = Loadable(lazy(() => import('pages/extra-pages/pages/extra-pages/sample-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: <DashboardLayout />,
      children: [
        {
          path: "dashboard",
          element: <DashboardDefault />,
        },
        {
          path: "users",
          element: <Users />,
        },
        { path: "companies-accounts", element: <CompaniesAccounts /> },
        { path: "company-activities", element: <CompanyActivities /> },
        { path: "job-activities", element: <JobActivities /> },
        { path: "course-categories", element: <CourseCategories /> },

        { path: "comment-actions", element: <CommentActions /> },

        { path: "roles", element: <Roles /> },
        { path: "translations", element: <Translations /> },
        { path: "categories", element: <Categories /> },
        { path: "countries", element: <Countries /> },
        { path: "resumes", element: <Resumes /> },
        { path: "search-resumes", element: <SearchResumes /> },
        { path: "mail-templates", element: <MailListPage /> },
        {
          path: "mail-templates/edit-mail-template/:mailId",
          element: <FormCustomerAdd />,
        },
        {
          path: "mail-templates/create-mail-template/:mailId",
          element: <FormCustomerAdd />,
        },

        { path: "admin-resume-note-type", element: <AdminResumeNoteType /> },

        // { path: "resumes/add-resume/:userId", element: <Profile /> },
        {
          path: "vacancy/edit-vacancy/:vacancyId",
          element: <FormVacancyManagmentEdit />,
        },
        {
          path: "vacancy/add-vacancy/:vacancyId",
          element: <FormVacancyManagmentEdit />,
        },
        {
          path: "static-pages/edit-page/:pageId",
          element: <AddEditPage />,
        },
        {
          path: "static-pages/add-page",
          element: <AddEditPage />,
        },
        {
          path: "jobseekers",
          element: <JobSeekers />,
        },
        {
          path: "vacancies",
          element: <VacanciesJobs />,
        },
        {
          path: "/vacancies/add-vacancy",
          element: <AddEditVacancy />,
        },
        {
          path: "/vacancies/edit-vacancy/:vacancyId",
          element: <AddEditVacancy />,
        },
        //

        //
        // {
        //   path: "active-resume",
        //   element: <ActiveResume />,
        // },
        // {
        //   path: "unactive-resume",
        //   element: <InactiveResume />,
        // },
        // { path: "resume/:resumeId", element: <Profile /> },
        { path: "banners", element: <Banners /> },
        { path: "bannerplace", element: <BannerPlace /> },

        { path: "best-place", element: <BestPlace /> },
        { path: "top-company", element: <TopCompany /> },
        { path: "jobtypes", element: <JobTypes /> },
        { path: "educational", element: <Educational /> },
        { path: "payment", element: <Payment /> },
        { path: "jobavailabilities", element: <JobAva /> },
        { path: "degree", element: <Degree /> },
        { path: "language", element: <Language /> },
        { path: "skills", element: <Skills /> },
        { path: "vacancies-packages", element: <VacanciesPackages /> },
        { path: "vacancy-subscriptions", element: <VacanciesSub /> },
        { path: "resume-subscriptions", element: <ResumeSub /> },
        { path: "resumes-packages", element: <ResumePackages /> },
        { path: "orders", element: <Orders /> },
        { path: "orders/edit-order/:orderId", element: <AddEditOrder /> },
        //purchased-resumes
        { path: "purchased-resumes", element: <PurchasedResumes /> },

        { path: "question", element: <Question /> },
        { path: "resumes/add-resume", element: <ResumeForm /> },
        { path: "resumes/edit-resume/:resumeId", element: <ResumeForm /> },
        { path: "resumes/view-resume/:resumeId", element: <ResumeForm /> },

        { path: "currency", element: <CurrencyList /> },
        { path: "titles", element: <TitleList /> },
        { path: "bank", element: <BankList /> },

        { path: "training-courses", element: <TrainingCourses /> },
        { path: "training-courses/add-course", element: <AddEditCourse /> },
        {
          path: "training-courses/edit-course/:id",
          element: <AddEditCourse />,
        },

        { path: "training-centers", element: <TrainingCenters /> },

        { path: "course", element: <DashboardDefault /> },
        { path: "coursecategories", element: <DashboardDefault /> },
        { path: "educationalcompanies", element: <DashboardDefault /> },
        { path: "coursecertificates", element: <DashboardDefault /> },
        { path: "coursedays", element: <DashboardDefault /> },
        { path: "coursepriods", element: <DashboardDefault /> },
        { path: "addedtutorials", element: <DashboardDefault /> },
        { path: "requestedtutorials", element: <DashboardDefault /> },
        { path: "tutorialpackages", element: <DashboardDefault /> },
        { path: "tutorialcategories", element: <DashboardDefault /> },
        { path: "tutorialtargetedsegments", element: <DashboardDefault /> },
        {
          path: "suggestededucationalinstitution",
          element: <DashboardDefault />,
        },
        { path: "educationalexperiencelist", element: <DashboardDefault /> },

        { path: "companies-list", element: <CompanyProfileList /> },
        { path: "vacancies-list", element: <VacanciesList /> },
        { path: "applications-list", element: <ApplicationsList /> },

        { path: "search-companies", element: <SearchCompanies /> },

        { path: "service-persons", element: <DashboardDefault /> },

        { path: "companies-replies", element: <CompanyReplies /> },
        { path: "companies-reports", element: <CompanyReports /> },
        {
          path: "companies-comments",
          element: <CompanyComments />,
        },

        {
          path: "/companies-list/add-company",
          element: <AddEditCompanyProfile />,
        },

        {
          path: "companies-list/view-company-details/:companyId",
          element: <ViewCompanyDetails />,
        },
        {
          path: "companies-list/edit-company/:companyId",
          element: <AddEditCompanyProfile />,
        },
        {
          path: "companies-reports/edit-company/:companyId",
          element: <AddEditCompanyProfile />,
        },
        {
          path: "static-pages/",
          element: <StaticPages />,
        },
        {
          path: "edit-role/:roleId",
          element: <FormRolesManagmentEdit />,
        },
        {
          path: "add-role",
          element: <FormRolesManagmentEdit />,
        },

        {
          path: "companies-reports/report-candidate",
          element: <ReportList />,
        },

        {
          path: "jobseekers/add-jobseeker",
          element: <AddEditJobSeeker />,
        },
        {
          path: "jobseekers/edit-jobseeker/:jobseekerId",
          element: <AddEditJobSeeker />,
        },
        {
          path: "comment-action",
          element: <CommentActionsList />,
        },
        {
          path: "report-candidate",
          element: <ReportList />,
        },
        {
          path: "articles-list",
          element: <Articles />,
        },
        {
          path: "articles-list/add-article",
          element: <AddEditArticle />,
        },
        {
          path: "articles-list/edit-article/:id",
          element: <AddEditArticle />,
        },
        {
          path: "articles-categories",
          element: <ArticlesCategories />,
        },
        {
          path: "comments-list",
          element: <Comments />,
        },
        {
          path: "comments-list/add-comment",
          element: <AddEditComment />,
        },
        {
          path: "comments-list/edit-comment/:id",
          element: <AddEditComment />,
        },
      ],
    },

    {
      path: "/",
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        {
          path: "contact-us",
          element: <AppContactUS />,
        },
      ],
    },
    {
      path: "/maintenance",
      element: <PagesLayout />,
      children: [
        {
          path: "404",
          element: <MaintenanceError />,
        },
        {
          path: "500",
          element: <MaintenanceError500 />,
        },
        {
          path: "under-construction",
          element: <MaintenanceUnderConstruction />,
        },
        {
          path: "coming-soon",
          element: <MaintenanceComingSoon />,
        },
      ],
    },
    {
      path: "*",
      element: <MaintenanceError />,
    },
  ],
};

export default MainRoutes;
